<div class="n-oldalfej">
  <div>
    <h2>NAV-kapcsolat (M2M)</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} · a gépi beküldés és lekérdezés hitelesítője</span>
  </div>
  <div class="spacer"></div>
  <span class="m2m-jelzo" *ngIf="allapot" [class.eles]="allapot.hasznalt === 'eles'">
    <ion-icon [name]="allapot.hasznalt === 'eles' ? 'radio-button-on-outline' : 'flask-outline'"></ion-icon>
    {{ allapot.hasznalt === 'eles' ? 'ÉLES környezet van használatban' : 'Tesztkörnyezet van használatban' }}
  </span>
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="betoltes()">
    <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
  </ion-button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet.</div>
<div class="ures" *ngIf="aktiv.ugyfelId && betolt"><ion-spinner name="dots"></ion-spinner>Betöltés…</div>

<ng-container *ngIf="allapot && !betolt">
  <div class="n-panel m2m-fej">
    <div class="n-panel-cim">Hogyan működik</div>
    <p class="halvany">
      A NAV két szinten hitelesít: a <b>szoftver</b> (kliens azonosító és jelszó) és az <b>adózó</b>
      (technikai felhasználó, jelszó, valamint egy két félből álló aláírókulcs). A kulcs második felét
      a NAV nem adja ki készen: a regisztrációkor kapott <b>kiváltó kóddal</b> kell lekérni, majd a
      felhasználót aktiválni – ezt a „Kulcs kiváltása és aktiválás” gomb elvégzi.
    </p>
    <p class="halvany">
      A tesztkörnyezetnek (<code>{{ allapot.teszt.bazis }}</code>) <b>saját regisztrációja</b> van, külön
      kliens azonosítóval, felhasználóval és teszt-adószámmal; az éles az <code>{{ allapot.eles.bazis }}</code>.
      A kettő hitelesítője nem cserélhető. Beküldeni mindig abba a környezetbe fogunk, amelyik <b>használatban</b> van.
    </p>
    <p class="cimke petrol" *ngIf="allapot.kozos">
      Közös a másik modul ügyfelével: {{ allapot.kapcsolt?.nev }} – elég egy helyen beállítani.
    </p>
    <p class="halvany" *ngIf="!allapot.kozos && modul === 'BER'">
      Ez az ügyfél nincs összekötve könyvelési ügyféllel, ezért a beállítás csak a Bérben él
      (összekötni az Ügyfelek oldalon lehet).
    </p>
  </div>

  <!--  NÉMA VISSZAESÉS: az élest jelölték ki, de hiányos → a rendszer a tesztet használná.
        Ezt eddig semmi nem mutatta, és a lekérdezés teszt-adatot adott vissza valódiként. -->
  <div class="n-panel m2m-figyelmeztetes" *ngIf="allapot?.visszaesett">
    <ion-icon name="warning-outline"></ion-icon>
    <div>
      <b>Az ÉLES kapcsolat van kijelölve, de hiányos</b> – ezért a rendszer a <b>tesztkörnyezetet</b> használná.
      Hiányzik: {{ (allapot.visszaesett.hiany || []).join(', ') }}.
      A lekérdezések (pl. EFO-napok) emiatt hibát jeleznek, nem adnak vissza teszt-adatot valódiként.
    </div>
  </div>

  <div class="m2m-racs">
    <!-- Egy kártya környezetenként -->
    <ng-container *ngFor="let k of kornyezetek">
      <div class="n-panel m2m-kartya" [class.hasznalt]="allapot.hasznalt === k" [class.eles]="k === 'eles'">
        <div class="m2m-kfej">
          <div class="n-panel-cim">{{ kornyezetCim(k) }}</div>
          <span class="cimke" [class.zold]="allapot[k].kesz" [class.sarga]="!allapot[k].kesz"
                [title]="allapot[k].kesz ? '' : ('Hiányzik: ' + (allapot[k].hiany || []).join(', '))">
            {{ allapot[k].kesz ? 'hitelesítő kész' : 'hiányos' }}</span>
          <span class="cimke petrol" *ngIf="allapot.hasznalt === k">használatban</span>
          <span class="spacer"></span>
          <button type="button" class="ov-gomb" *ngIf="allapot.hasznalt !== k" [disabled]="fut" (click)="valt(k)">
            <ion-icon name="swap-horizontal-outline"></ion-icon>Ezt használom</button>
        </div>
        <p class="halvany m2m-url"><code>{{ allapot[k].bazis }}</code></p>
        <!--  MI HIÁNYZIK. A „hiányos" felirat önmagában nem mondta meg, mit kell pótolni. -->
        <p class="m2m-hiany" *ngIf="!allapot[k].kesz && (allapot[k].hiany || []).length">
          <ion-icon name="alert-circle-outline"></ion-icon>
          Hiányzik: {{ allapot[k].hiany.join(', ') }}
        </p>

        <!-- A NAV gyakran egy sorban, kötőjelekkel adja ki a hitelesítőt – ez is beilleszthető. -->
        <label class="kv-mezo m2m-egysoros"><span>API kulcs egyben</span>
          <input type="text" [(ngModel)]="urlap[k].api_kulcs"
                 placeholder="felhasználó-jelszó-aláírókulcs1-kiváltókód"></label>
        <p class="halvany m2m-sugo">Ha a NAV egy sorban, kötőjelekkel adta meg, ide elég beilleszteni – mentéskor
          szétbontjuk az alábbi mezőkre. (Ötödik szakaszként az aláírókulcs második fele is jöhet.)</p>

        <!-- Élesben a kliens-hitelesítő a SZOFTVERÉ: minden ügyfélnél ugyanaz, a telepítés
             beállításából jön – itt csak megmutatjuk. Tesztben regisztrációnként saját. -->
        <div class="kv-mezo m2m-kliens" *ngIf="allapot[k].kliens_beegetve">
          <span>Kliens azonosító</span>
          <div>
            <b *ngIf="allapot[k].van_kliens" class="m2m-masolhato">{{ allapot[k].kliens_id }}</b>
            <button type="button" class="m2m-masol" *ngIf="allapot[k].van_kliens" (click)="masol(allapot[k].kliens_id)" title="Másolás a vágólapra"><ion-icon name="copy-outline"></ion-icon></button>
            <span class="cimke sarga" *ngIf="!allapot[k].van_kliens">nincs beállítva a kiszolgálón</span>
            <span class="halvany"> – a szoftver közös hitelesítője (minden ügyfélnél ugyanez)</span>
          </div>
        </div>
        <ng-container *ngIf="!allapot[k].kliens_beegetve">
          <label class="kv-mezo"><span>Kliens azonosító</span>
            <input type="text" [(ngModel)]="urlap[k].kliens_id" [placeholder]="allapot[k].kliens_id ? 'üresen hagyva a mentett marad' : 'a teszt regisztrációból'"></label>
          <!-- A mentett kliens azonosító teljesen, kijelölhetően és egy gombbal másolhatóan (a helyőrző szöveg nem másolható). -->
          <div class="kv-mezo m2m-kliens" *ngIf="allapot[k].kliens_id">
            <span>Mentett kliens azonosító</span>
            <div><b class="m2m-masolhato">{{ allapot[k].kliens_id }}</b>
              <button type="button" class="m2m-masol" (click)="masol(allapot[k].kliens_id)" title="Másolás a vágólapra"><ion-icon name="copy-outline"></ion-icon></button></div>
          </div>
          <label class="kv-mezo"><span>Kliens jelszó</span>
            <input type="password" [(ngModel)]="urlap[k].kliens_titok" autocomplete="new-password"
                   [placeholder]="allapot[k].kliens_id ? 'mentve – üresen hagyva megmarad' : ''"></label>
        </ng-container>
        <label class="kv-mezo"><span>Felhasználónév</span>
          <input type="text" [(ngModel)]="urlap[k].felhasznalo" [placeholder]="allapot[k].felhasznalo || 'technikai felhasználó'"></label>
        <label class="kv-mezo"><span>Felhasználó jelszó</span>
          <input type="password" [(ngModel)]="urlap[k].jelszo" autocomplete="new-password"
                 [placeholder]="allapot[k].van_jelszo ? 'mentve – üresen hagyva megmarad' : ''"></label>
        <label class="kv-mezo"><span>Aláírókulcs első fele</span>
          <input type="text" [(ngModel)]="urlap[k].kulcs1" [placeholder]="allapot[k].kulcs1 || ''"></label>
        <label class="kv-mezo"><span>Kulcs 2. felének kiváltó kódja</span>
          <input type="text" [(ngModel)]="urlap[k].nonce" [placeholder]="allapot[k].van_nonce ? 'mentve' : 'a regisztrációból'"></label>
        <label class="kv-mezo" *ngIf="k === 'teszt'"><span>Teszt adóazonosító</span>
          <input type="text" [(ngModel)]="urlap[k].teszt_adoszam" [placeholder]="allapot[k].adoszam || 'a teszt regisztrációból'"></label>

        <div class="m2m-kulcs2">
          <span class="cimke" [class.zold]="allapot[k].van_kulcs2">{{ allapot[k].van_kulcs2 ? 'Aláírókulcs 2. fele megvan' : 'Aláírókulcs 2. fele hiányzik' }}</span>
          <span class="halvany" *ngIf="allapot[k].aktivalva">aktiválva: {{ allapot[k].aktivalva | date:'yyyy.MM.dd HH:mm' }}</span>
        </div>

        <div class="m2m-gombok">
          <button type="button" class="ov-gomb fo" [disabled]="fut === 'ment-' + k" (click)="ment(k)">
            <ion-icon name="save-outline"></ion-icon>Mentés</button>
          <button type="button" class="ov-gomb" [disabled]="fut === 'kulcs-' + k || (!allapot[k].van_nonce && !urlap[k].nonce)" (click)="kulcs(k)">
            <ion-icon name="key-outline"></ion-icon>{{ fut === 'kulcs-' + k ? 'Kiváltás…' : 'Kulcs kiváltása és aktiválás' }}</button>
          <button type="button" class="ov-gomb" [disabled]="fut === 'proba-' + k || !allapot[k].kesz" (click)="proba(k)">
            <ion-icon name="pulse-outline"></ion-icon>{{ fut === 'proba-' + k ? 'Próba…' : 'Kapcsolat próbája' }}</button>
        </div>
        <p class="halvany m2m-sugo" *ngIf="k === 'teszt'">A tesztkörnyezetbe küldött bevallásnak nincs joghatása –
          itt lehet végigpróbálni a beküldést.</p>
        <p class="halvany m2m-sugo" *ngIf="k === 'eles'">Élesben a beküldés valódi bevallás. A váltáshoz külön megerősítés kell.</p>
      </div>
    </ng-container>
  </div>
</ng-container>

<!-- ══════════ NAV TECHNIKAI FELHASZNÁLÓ (ONLINE SZÁMLA) ══════════
     A Könyvelésben ennek saját oldala van (Szervíz › NAV technikai felhasználó) – ott szerkeszthető, itt csak
     az állapota látszik (ugyanaz az adat: naplo_nav_tech). A BÉR-ben nincs külön oldal, ott itt szerkeszthető. -->
<div class="n-panel" *ngIf="osa && modul === 'NAPLO'" style="margin-top:14px">
  <div class="n-panel-cim">NAV technikai felhasználó (Online Számla)</div>
  <p class="halvany" style="margin:0 0 8px;font-size:.84rem">
    Ez nem az M2M-hitelesítő: az Online Számla, a pénztárgép-napló, a NAV törzsadat és az eÁFA hitelesítője. A Könyvelésben a saját oldalán állítod be.
  </p>
  <div class="m2m-osa-allapot">
    <span *ngFor="let k of kornyezetek"><b>{{ kornyezetCim(k) }}:</b>
      <span class="cimke" [class.zold]="osa[k].konfiguralt">{{ osa[k].konfiguralt ? 'beállítva' : 'hiányos' }}</span>
      <span class="cimke petrol" *ngIf="osa.hasznalt === k">használatban</span></span>
    <a class="ov-gomb" routerLink="/naplo/torzsek" [queryParams]="{ nezet: 'osa' }"><ion-icon name="key-outline"></ion-icon>Megnyitás: NAV technikai felhasználó</a>
  </div>
</div>
<div class="n-panel" *ngIf="osa && modul === 'BER'" style="margin-top:14px">
  <div class="n-panel-cim">NAV technikai felhasználó (Online Számla)</div>
  <p class="halvany" style="margin:0 0 10px;font-size:.84rem">
    Ugyanennek a cégnek a NAV Online Számla hitelesítője: ebből megy a számla-szinkron, a
    <b>NAV törzsadat</b>, az adószám-ellenőrzés és a bérben az <b>EFO-lekérdezés</b> is.
    A NAV tesztrendszeréhez külön regisztráció tartozik, ezért a teszt és az éles hitelesítő is eltárolható –
    a jelölt lép életbe.
    <ng-container *ngIf="osa.kozos"><br>Ez a beállítás <b>közös</b> a kapcsolt céggel ({{ osa.kapcsolt?.nev }}) – elég egy helyen megadni.</ng-container>
  </p>

  <div class="m2m-racs" style="margin-left:0;margin-right:0">
    <div class="n-panel m2m-kartya" *ngFor="let k of kornyezetek" [class.hasznalt]="osa.hasznalt === k" [class.eles]="k === 'eles'">
      <div class="m2m-kfej">
        <div class="n-panel-cim">{{ kornyezetCim(k) }}</div>
        <span class="cimke" [class.zold]="osa[k].konfiguralt">{{ osa[k].konfiguralt ? 'beállítva' : 'hiányos' }}</span>
        <span class="cimke petrol" *ngIf="osa.hasznalt === k">használatban</span>
        <span class="spacer"></span>
        <button type="button" class="ov-gomb" *ngIf="osa.hasznalt !== k" [disabled]="fut === 'osa-valt' || !osa[k].konfiguralt"
                (click)="osaValt(k)"><ion-icon name="swap-horizontal-outline"></ion-icon>Átváltok erre</button>
      </div>
      <label class="kv-mezo"><span>Technikai felhasználó</span>
        <input type="text" [(ngModel)]="osaUrlap[k].login" [ngModelOptions]="{standalone:true}" autocomplete="off"></label>
      <label class="kv-mezo"><span>Jelszó</span>
        <input type="password" [(ngModel)]="osaUrlap[k].jelszo" [ngModelOptions]="{standalone:true}" autocomplete="new-password"
               [placeholder]="osa[k].hasJelszo ? 'mentve – üresen hagyva megmarad' : ''"></label>
      <label class="kv-mezo"><span>Adószám (8 jegy)</span>
        <input type="text" [(ngModel)]="osaUrlap[k].adoszam" [ngModelOptions]="{standalone:true}" maxlength="8"></label>
      <label class="kv-mezo"><span>Aláírókulcs</span>
        <input type="password" [(ngModel)]="osaUrlap[k].signkey" [ngModelOptions]="{standalone:true}" autocomplete="new-password"
               [placeholder]="osa[k].hasSignkey ? 'mentve – üresen hagyva megmarad' : ''"></label>
      <label class="kv-mezo"><span>Cserekulcs</span>
        <input type="password" [(ngModel)]="osaUrlap[k].exchangekey" [ngModelOptions]="{standalone:true}" autocomplete="new-password"
               [placeholder]="osa[k].hasExchangekey ? 'mentve – üresen hagyva megmarad' : 'csak számla-beküldéshez kell'"></label>
      <div class="m2m-gombok">
        <button type="button" class="ov-gomb fo" [disabled]="fut === 'osa-ment-' + k" (click)="osaMent(k)">
          <ion-icon name="save-outline"></ion-icon>Mentés</button>
        <button type="button" class="ov-gomb" *ngIf="osa.hasznalt === k" [disabled]="fut === 'osa-proba' || !osa.konfiguralt" (click)="osaProba()">
          <ion-icon name="pulse-outline"></ion-icon>{{ fut === 'osa-proba' ? 'Próba…' : 'Kapcsolat próbája' }}</button>
      </div>
      <p class="halvany m2m-sugo" *ngIf="k === 'teszt'">A NAV tesztrendszere (api-test) – valós számlaadat nem kerül be.</p>
    </div>
  </div>

  <div class="sa-jelolok" style="margin:10px 0 0">
    <label><input type="checkbox" [ngModel]="osa.kep_auto" [ngModelOptions]="{standalone:true}"
                  (ngModelChange)="osaKepAuto($event)"> számlaképek automatikus letöltése</label>
  </div>
</div>
